// extracted by mini-css-extract-plugin
export default {"instalmentForm":"hPUenpdLdhmqsyj6uh6A","inputContainer":"hartpLKbLXS89WdsmPzv","marginTop":"AeCjQWMCjGUOv_nqWQjb"};